// extracted by mini-css-extract-plugin
module.exports = {"cellWrapper":"style_cellWrapper__L-u12","cellContentWrapper":"style_cellContentWrapper__3txba","alignedCellsWrapper":"style_alignedCellsWrapper__1BwYA"};